import styled from 'styled-components';

const TripleSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const TripleSectionImage = styled.img`
  width: 100%;

  border-radius: ${(props) => props.theme.radius.md};
`;
const TripleSectionText = styled.div`
  width: 100%;
`;

export { TripleSection, TripleSectionImage, TripleSectionText };
